import { IStore } from '../index'
import { createSelector } from 'reselect'
import { getFilteredRoomsWithEvents } from '../bookingCalendar/selectors/rooms'

export const getAirbnbStatus = (store: IStore) => store.integration.status

export const getAirbnbAgreement = (store: IStore) => store.integration.agreement

export const getAirbnbChecked = (store: IStore) => store.integration.checked

export const getAirbnbListings = (store: IStore) =>
  store.integration.listings.sort((a, b) => a.name.localeCompare(b.name))

export const getAirbnbTab = (store: IStore) => store.integration.tab

export const getAirbnbBackdrop = (store: IStore) => store.integration.backdrop

export const getAirbnbSync = (store: IStore) => store.integration.sync

export const getAirbnbSavingConfiguration = (store: IStore) =>
  store.integration.savingConfiguration

export const getAirbnbPriceTab = (state: IStore) => state.integration.priceTab

export const getBookingPropertyModalStep = (state: IStore) =>
  state.integration.step

export const getBookingPropertyModalConfirmStep = (state: IStore) =>
  state.integration.confirmStep

export const getBookingConfirmModalOpen = (state: IStore) => state.integration.confirmModal

export const getAirbnbNotAllConnectedModal = (state: IStore) =>
  state.integration.notConnectedModal

export const getAirbnbPrices = (state: IStore) => state.integration.prices

export const getAirbnbConnectedListings = createSelector(
  [getAirbnbListings],
  listings => listings.filter(l => Number(l.bedbooking_id_room) !== 0),
)

export const getAirbnbLoadingPrice = (state: IStore) =>
  state.integration.loadingPrice

export const getAirbnbLoadingConfiguration = (state: IStore) =>
  state.integration.loadingConfiguration

export const getAirbnbLoadingListing = (state: IStore) =>
  state.integration.loadingListings

export const getAirbnbConfiguration = (state: IStore) =>
  state.integration.configuration

export const getListingByRoomId = createSelector(
  [getAirbnbListings],
  listings => id =>
    listings.find(l => String(l.bedbooking_id_room) === String(id)),
)

export const getAirbnbRoomsWithPrices = createSelector(
  [getFilteredRoomsWithEvents, getAirbnbPrices],
  (rooms, prices) =>
    rooms.map(r => {
      const roomPrice = prices
        ? prices.find(price => String(price.id_room) === String(r.id))
        : null

      if (!roomPrice) {
        return {
          ...r,
          prices: {
            prices: [],
          },
        }
      }

      const normalizedPrices = (roomPrice.prices.length === undefined
        ? [roomPrice.prices]
        : roomPrice.prices) as any

      const mappedPrice = {
        ...roomPrice,
        prices: normalizedPrices,
        restrictions: [],
      }

      return {
        ...r,
        prices: mappedPrice,
      }
    }),
)
